__turbopack_context__.v({
  "dropWrapper": "DropButton-module__f4k08q__dropWrapper",
  "dropZone": "DropButton-module__f4k08q__dropZone",
  "wrapper": "DropButton-module__f4k08q__wrapper",
});
